'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var runtypes = require('runtypes');

const PingMessage = runtypes.Record({
    type: runtypes.Literal("ping"),
    nonce: runtypes.Number,
});
const PongMessage = runtypes.Record({
    type: runtypes.Literal("pong"),
    nonce: runtypes.Number,
});
const PingPongMessages = runtypes.Union(PingMessage, PongMessage);
const PingPongOptions = runtypes.Partial({
    interval: runtypes.Number,
    timeout: runtypes.Number,
    verbose: runtypes.Boolean,
});
const pingPongDefaultOptions = {
    interval: 8000,
    timeout: 1000,
    verbose: false,
};
function PongWS(ws, o = {}) {
    const { interval, timeout, verbose } = { ...pingPongDefaultOptions, ...o };
    let pongTimer;
    let nonce;
    let pongTimeout;
    function startPongTimer() {
        pongTimer = setInterval(() => {
            if (pongTimeout) {
                clearTimeout(pongTimeout);
            }
            nonce = Math.floor(Math.random() * 1024 * 1024);
            if (verbose) {
                console.log(`-> pong ${nonce}`);
            }
            ws.send(JSON.stringify(PongMessage.check({ type: "pong", nonce })));
            pongTimeout = setTimeout(() => {
                ws.close();
            }, timeout);
        }, interval);
    }
    if (ws.readyState === ws.OPEN) {
        startPongTimer();
    }
    else {
        ws.addEventListener("open", startPongTimer);
    }
    ws.addEventListener("message", ({ data }) => {
        const message = JSON.parse(data);
        if (PongMessage.guard(message) && message.nonce === nonce && pongTimeout) {
            if (verbose) {
                console.log(`<- pong ${nonce}`);
            }
            clearTimeout(pongTimeout);
        }
        else if (PingMessage.guard(message)) {
            ws.send(data);
        }
    });
    ws.addEventListener("close", () => {
        if (pongTimer) {
            clearInterval(pongTimer);
        }
        if (pongTimeout) {
            clearTimeout(pongTimeout);
        }
    });
    return ws;
}
function PingWS(ws, o = {}) {
    const { interval, timeout, verbose } = { ...pingPongDefaultOptions, ...o };
    let pingTimer;
    let nonce;
    let pingTimeout;
    function startPingTimer() {
        pingTimer = setInterval(() => {
            if (pingTimeout) {
                clearTimeout(pingTimeout);
            }
            nonce = Math.floor(Math.random() * 1024 * 1024);
            if (verbose) {
                console.log(`-> ping ${nonce}`);
            }
            ws.send(JSON.stringify(PingMessage.check({ type: "ping", nonce })));
            pingTimeout = setTimeout(() => {
                ws.close();
            }, timeout);
        }, interval);
    }
    if (ws.readyState === ws.OPEN) {
        startPingTimer();
    }
    else {
        ws.addEventListener("open", startPingTimer);
    }
    ws.addEventListener("message", ({ data }) => {
        const message = JSON.parse(data);
        if (PingMessage.guard(message) && message.nonce === nonce && pingTimeout) {
            if (verbose) {
                console.log(`<- ping ${nonce}`);
            }
            clearTimeout(pingTimeout);
        }
        else if (PongMessage.guard(message)) {
            ws.send(data);
        }
    });
    ws.addEventListener("close", () => {
        if (pingTimer) {
            clearInterval(pingTimer);
        }
        if (pingTimeout) {
            clearTimeout(pingTimeout);
        }
    });
    return ws;
}
function filterPingPongMessages(listener) {
    return (event) => {
        try {
            const message = JSON.parse(event.data);
            if (PingPongMessages.guard(message)) {
                return;
            }
        }
        catch (err) { }
        return listener(event);
    };
}

exports.PingPongMessages = PingPongMessages;
exports.PingPongOptions = PingPongOptions;
exports.PingWS = PingWS;
exports.PongWS = PongWS;
exports.filterPingPongMessages = filterPingPongMessages;
exports.pingPongDefaultOptions = pingPongDefaultOptions;
//# sourceMappingURL=index.cjs.js.map
